import React, { memo, useEffect, useState, useRef } from "react";
import CountDown, { CountdownApi } from "react-countdown";
import { convertMs, getSessionId, checkMob, getServerTimeOffset, currentTimeValidWrtServerTime } from "lib/utils/helperMethods";
import { Tooltip, Button, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "components/UI/Segment/UIHelper";
import { attemptedCountSelector } from "../FirestoreInteractions/selector";
import { useTranslate } from "lib/MrTranslate/MrTranslate";


const CountDownTimer = memo(
  ({
    startedAt,
    duration,
    multi = false,
    extra_time = 0,
    extra_time_offset = 0,
    setUserInfo = {},
    setIsTimeUp = {},
    mobileUploadMode = false,
    experienceSettings = {},
    forMonitor = false,
    currentView,
    questionsCount,
    setSwitchFromStartToResumeView,
    setServerTimeCallback,
  }) => {
    const mrIntl = useTranslate()
    const isMobile = checkMob();
    // const [exTime, setExTime] = useState(0);
    // const [exTimeOffset, setExTimeOffset] = useState(0);
    const studentTimer = useRef(null);
    const studentStartedAt = startedAt == undefined ? Date.now() : startedAt;
    let calcTargetTime =
      studentStartedAt +
      (multi ? duration : convertMs(duration)) +
      extra_time +
      extra_time_offset;
    const [targetTime, setTargetTime] = useState(calcTargetTime);
    useEffect(() => {
    console.log("CountDownTimer extra_time==>", extra_time);
      if (typeof extra_time != "undefined") {
        // setExTime(extra_time);
        let calcTargetTime =
          studentStartedAt +
          (multi ? duration : convertMs(duration)) +
          extra_time +
          extra_time_offset;
        setTargetTime(calcTargetTime);
        if (calcTargetTime > Date.now()) {
          // TODO: set in userinfo?
          // setIsTimeUp(false);
          if(!forMonitor){
            setUserInfo({
              is_time_up: false
            });
          }
          // if(currentView == "startTest"){
          //   setUserInfo({currentView: "endTest", is_uploading_finished: true, ended_at: Date.now()})
          // }
        }
      }
    }, [extra_time]);
    // console.log("CountDownTimer studentStartedAt", studentStartedAt, extra_time);

    // if endedAt < studentStartedAt + convertMs(duration)
    // exTimeOffset = 0
    // else
    // let exTimeOffset = Date.now()-(studentStartedAt + convertMs(duration))
    // let targetTime = studentStartedAt + (multi ? duration : convertMs(duration)) + extra_time + extra_time_offset
    const attemptedCount = useSelector(attemptedCountSelector)
    const questionsLeft = questionsCount - attemptedCount
    console.log("targetTime", attemptedCount, questionsLeft, questionsCount);
    
    // let targetTime = studentStartedAt + (multi ? duration : convertMs(duration)) + (exTime)
    
    // Todo: this extra time will work if test still in progress. if adding after ending - set studentStartedAt again and add just the extraTime - log how many times and when extra time added. after end test essentially a restart of the test
    useEffect(() => {
      console.log("Countdowntimer on mount", targetTime, extra_time, extra_time_offset, forMonitor, Date.now(), currentView);
      if (!forMonitor && targetTime < Date.now()) {
        // setIsTimeUp(true); // want this in endTest case too
        let userInfoObj = {
          is_time_up: true,
        }
        if (currentView === "startTest" || currentView === "resumeTest") {
          setSwitchFromStartToResumeView(false);
          userInfoObj = {
            ...userInfoObj,
            currentView: "endTest",
            is_uploading_finished: true,
            ended_at: Date.now(),
          }
          setTimeout(() => {
            setUserInfo(userInfoObj,
            {
              log: {
                // logging: experienceItemConfig.log.logging,
                logging: true,
                action: "test_ended_on_time_completed",
              },
            });
          }, 1000)
        }
        // want is_time_up to be set in endTest case too but no currentView change
        if (currentView === "endTest") {
          setTimeout(() => {
            setUserInfo(userInfoObj);
          }, 1000)
        }
      }
    }, []);
    // let isTimeUp = targetTime <= Date.now() ? true : false

    const onTick = (data) => {
      if (data.hours == 0 && data.minutes == 10 && data.seconds == 0) {
        var description;
        var message;
        if (
          experienceSettings.allow_student_upload_files &&
          !mobileUploadMode
        ) {
          message = mrIntl("CountDownTimer.last_10_minutes_left")
          description = `\n${
            isMobile
              ? mrIntl("CountDownTimer.please_make_sure_you_upload_your_handwritten_answers")
              : `${mrIntl("CountDownTimer.click_on_upload_btn")} \n${
                  questionsLeft !== 0 &&
                  `${mrIntl("CountDownTimer.unanswered_questions" , {questionsLeft: questionsLeft })}`
                }`
          }`;
        } else if (questionsLeft !== 0) {
          message = mrIntl("CountDownTimer.last_10_minutes_left")
          // description = `You have ${questionsLeft} unanswered questions.`;
          description = mrIntl("CountDownTimer.unanswered_questions" , {questionsLeft: questionsLeft });

        }
        showNotification("warning", {
          message: message,
          description: description,
          duration: 10,
          top: 65,
        });
      } else if (data.hours == 0 && data.minutes == 2 && data.seconds == 0) {
        showNotification("warning", {
          message: mrIntl("CountDownTimer.only_2_minutes_left"),
          description:
            mrIntl("CountDownTimer.this_test_will_end_in_minutes_please_make_sure_to_review_your_answers"),
          duration: 10,
          top: 65,
        });
      }
    };

    let finalRender = forMonitor ? (
      <Tag color="processing">
        <CountDown
          key="experience-timer"
          daysInHours={true}
          // date={Date.now() + 10000 + (exTime !== 0 && exTime)}
          date={targetTime}
          controlled={false}
          // Todo - do this on teacher side also - end test?
          onComplete={() => {
            // Want to avoid calling updateRecord / updating user_info from teacher side - in case any issues, will end test/is_time_up = true for student - instead doing an extra 
            // TODO: set in userinfo?
            // setIsTimeUp(true);
            // TODO: set in userinfo from here also - only case where there will be an issue is when time ends but student offline - is_time_up will not be set to true and adding time may be inaccurate
          }}
        />
      </Tag>
    ) : (
      <Tooltip title={mrIntl("CountDownTimer.time_left")} placement="bottom" getPopupContainer={triggerNode => triggerNode.parentNode}>
        <Button ref={studentTimer} size={isMobile && "small"}>
          <CountDown
            key="experience-timer"
            daysInHours={true}
            // date={Date.now() + 10000 + (exTime !== 0 && exTime)}
            date={targetTime}
            controlled={false}
            onMount={() => getServerTimeOffset(setServerTimeCallback)}
            onTick={(data) => onTick(data)}
            onComplete={() => {
              console.log("timer complete")
              if (studentTimer.current) {
                studentTimer.current.focus(); // Focusing to trigger blur on text editors to auto save answers
              }
              setSwitchFromStartToResumeView(false);
              // setIsTimeUp(true);
              // if (currentView === "startTest") {
                // ISsue here - ended_at not being updated when sitting on endTest and test ends = removing startTest condition -calling this anytime onComplete triggers - resumeTest, startTest, endTest. It doesn't trigger if time over already and page refreshed.
                setUserInfo(
                  { currentView: "endTest", ended_at: Date.now(), is_time_up: true },
                  {
                    log: {
                      // logging: experienceItemConfig.log.logging,
                      logging: true,
                      action: "test_ended_on_time_completed",
                    },
                  }
                );
              // }
            }}
          />
        </Button>
      </Tooltip>
    );

    return <>{finalRender}</>;
  }
);
export default CountDownTimer;
